import { apiFetch } from './client';

export interface ApiSummary {
  apiId: string;
  displayName: string;
}

export const listApis = () => apiFetch<ApiSummary[]>('/api/v1/apis');

export interface JiraFixVersion {
  id: string;
  name: string;
  released: boolean;
  releaseDate?: string;
  archived: boolean;
}

export const listJiraReleases = (apiId: string) =>
  apiFetch<JiraFixVersion[]>(`/api/v1/jira/releases?apiId=${encodeURIComponent(apiId)}`);

export interface SpecVariant {
  specId: string; // e.g. "v0", "v1"
  s3Key: string; // e.g. "skymap/2026-04-01/skymap.v0.yaml"
}

export interface ApiVersionSummary {
  apiId: string;
  versionId: string;
  displayName: string;
  releaseState: 'pre-release' | 'released';
  specVariants: SpecVariant[];
  changelogS3Key?: string;
  migrationGuideS3Key?: string;
  jiraReleaseId?: string;
  hotfix?: boolean;
  registeredAt: string;
  publishedAt?: string;
}

export const listVersions = (apiId: string) =>
  apiFetch<ApiVersionSummary[]>(`/api/v1/apis/${apiId}/versions`);

export const getVersion = (apiId: string, versionId: string) =>
  apiFetch<ApiVersionSummary>(`/api/v1/apis/${apiId}/versions/${encodeURIComponent(versionId)}`);

export const preRelease = (
  apiId: string,
  versionId: string,
  body: { displayName?: string; jiraReleaseId?: string },
) =>
  apiFetch<ApiVersionSummary>(
    `/api/v1/apis/${apiId}/versions/${encodeURIComponent(versionId)}/pre-release`,
    { method: 'POST', body: JSON.stringify(body) },
  );

export interface ImportSpecResponse {
  apiId: string;
  versionId: string;
  source: string;
  imported: { specId: string; s3Key: string; bytes: number }[];
}

export const importSpec = (
  apiId: string,
  versionId: string,
  body: { source: string; specIds?: string[]; jiraReleaseId?: string },
) =>
  apiFetch<ImportSpecResponse>(
    `/api/v1/apis/${apiId}/versions/${encodeURIComponent(versionId)}/import`,
    { method: 'POST', body: JSON.stringify(body) },
  );

export const publish = (apiId: string, versionId: string) =>
  apiFetch<{ apiId: string; versionId: string; publishedAt: string; hotfix: boolean }>(
    `/api/v1/apis/${apiId}/versions/${encodeURIComponent(versionId)}/publish`,
    { method: 'POST' },
  );

export const deletePreRelease = (apiId: string, versionId: string) =>
  apiFetch<{ apiId: string; versionId: string; deleted: boolean }>(
    `/api/v1/apis/${apiId}/versions/${encodeURIComponent(versionId)}/pre-release`,
    { method: 'DELETE' },
  );
